export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_00.d9a9228a.jpg";